
import { Button, IconButton, styled } from "@mui/material";

export const BookCourtButtonUI = styled(Button)(() => {
  return {
    position: 'fixed',
    top: '60%',
    right: -50,
    zIndex: 99,
    transform: 'rotateZ(-90deg)',
    fontSize: '1rem',
  }
})
export const CartButtonUI = styled(IconButton)(({ theme }) => {
  const { palette } = theme;
  return {
    position: 'fixed',
    top: 'calc(60% + 120px)',
    right: 6,
    zIndex: 999,
    color: palette.light.main,
    backgroundColor: palette.primary.main,
    animation: 'shake 4s ease-in-out 5s infinite both, none 5s infinite',
    '@keyframes shake': {
      '10%, 30%': {
        transform: 'scale(1.1)',
        rotate: '-5deg',
      },
      '20%, 80%': {
        transform: 'scale(1)',
        rotate: '5deg',
      },
      '30%, 50%, 70%': {
        transform: 'scale(0.9)',
        rotate: '0deg',
      },
      '15%, 25%': {
        transform: 'scale(1.05)',
        rotate: '2deg',
      }
    },
    '&:hover': {
      backgroundColor: palette.primary.focus,
    },
  }
})